import DataHeaderType from "../../../Types/DataHeaderType";

const menuItems: DataHeaderType[] = [
  {
    id: 1,
    name: "Программы",
    path: "#",
  },
  {
    id: 2,
    name: "Ближайшие мероприятия",
    path: "/calendar",
  },
  {
    id: 3,
    name: "Поиск врача",
    path: "/searchDoctor",
  },
  {
    id: 4,
    name: "Ассоциация PreventAge",
    path: "/association",
  },
  {
    id: 5,
    name: "Полезные статьи",
    path: "https://dzen.ru/preventage",
  },
]

export default menuItems
